import { inject, Pipe, PipeTransform, SecurityContext } from "@angular/core";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";

@Pipe({ name: 'sklHighlightText' })
export class HighlightTextPipe implements PipeTransform {

	readonly #sanitizer = inject(DomSanitizer);

	public transform(text: string | undefined | null, term: string): SafeHtml | string | null {
		if (!text) return '';
		if (!term) return text;

		// REGEX - escape special characters
		const re = new RegExp(`(${term.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`, 'gi');

		const highlighted = text.replace(re, '<mark>$1</mark>');

		return this.#sanitizer.sanitize(SecurityContext.HTML, highlighted);
	}
}
